const InformationMedium = [
  { label: "Face to Face", value: "Face to Face" },
  { label: "Voice Recording", value: "Voice Recording" },
  { label: "Text Message", value: "Text Message" },
  { label: "Person to Person", value: "Person to Person" },
];

export default InformationMedium;
